import { render, staticRenderFns } from "./PictureAsPDF.vue?vue&type=template&id=001c8b00&"
import script from "./PictureAsPDF.vue?vue&type=script&lang=js&"
export * from "./PictureAsPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports